import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(4),
  },
  horizontalDivider: {
    height: '1px',
    width: 'auto',
    backgroundColor: theme.palette.dividerV2.main,
    marginLeft: theme.spacing(-4),
    marginRight: theme.spacing(-4),
  },
  headerTitle: {
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: '#381E1C',
  },
  subTitle: {
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: theme.palette.labraText.description,
  },
  sectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  buttonFormSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  formFieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  feildsForm: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  selectorWidth: { width: theme.spacing(14.875) },
  colorSelectorWidth: { width: '265px' },
  colorSelectorWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  rootComp: {
    backgroundColor: theme.palette.background.paper,
  },
  content: {
    padding: theme.spacing(4, 5),
  },
}))
